import { Patient } from "src/careflow/ph-core/fhir-client/resources";
import { PatientRepository } from "../../../ports/out/repositories";
import { AxiosFHIRRepository } from "./AxiosFHIRRepository";
import { TokenSource } from "./TokenSource";
import axiosFhirInstance from "../instance/axiosFhirInstance";

export class FHIRPatientRepository extends AxiosFHIRRepository<Patient> implements PatientRepository {
  constructor(tokenSource?: TokenSource) {
    super('Patient', axiosFhirInstance, tokenSource);
  }
}